import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "appRedux/store"
import { CREATE } from "constants/index"

type ItemFormSlice = {
  formFields: WishItemRequestPayload;
  showChooseListsDropSheet: boolean;
  showCreateNewListOverlay: boolean;
  mode: FormMode;
}

const initialState = {
  formFields: {
    name: "",
    url: "",
    caption: "",
    image: "",
    wishlistIds: [],
    price: "",
    currency: ""
  },
  showChooseListsDropSheet: false,
  showCreateNewListOverlay: false,
  mode: CREATE
} as ItemFormSlice

export const itemFormSlice = createSlice({
  name: "itemFormSlice",
  initialState: initialState,
  reducers: {
    updateItemFormFieldsWithDefaultCurrency: (state, action: PayloadAction<WishItemRequestPayload & { currency: string }>) => {
      state.formFields = {
        ...action.payload,
        caption: action.payload.caption || "",
        url: action.payload.url || "",
        image: action.payload.image || "",
        price: action.payload.price || ""
      }
    },
    updateShowChooseListsDropSheet: (state, action: PayloadAction<boolean>) => {
      state.showChooseListsDropSheet = action.payload
    },
    updateShowCreateNewListOverlay: (state, action: PayloadAction<boolean>) => {
      state.showCreateNewListOverlay = action.payload
    },
    updateItemFormMode: (state, action: PayloadAction<FormMode>) => {
      state.mode = action.payload
    },
    resetItemFormSliceWithDefaultCurrency: (state, action: PayloadAction<string>) => {
      return {
        ...initialState,
        formFields: {
          ...initialState.formFields,
          currency: action.payload
        }
      }
    }
  }
})

export const {
  updateItemFormFieldsWithDefaultCurrency,
  updateShowChooseListsDropSheet,
  updateShowCreateNewListOverlay,
  updateItemFormMode,
  resetItemFormSliceWithDefaultCurrency
} = itemFormSlice.actions

export default itemFormSlice.reducer

export const updateItemFormFields = createAsyncThunk(
  "itemForm/updateFormFields",
  (payload: WishItemRequestPayload, { getState, dispatch }) => {
    const state = getState() as RootState
    const defaultCurrency = state.initSlice.supportedCurrencies.defaultCurrency || ""
    dispatch(
      updateItemFormFieldsWithDefaultCurrency({
        ...payload,
        currency: payload.currency || defaultCurrency
      })
    )
  }
)

export const resetItemFormSlice = createAsyncThunk(
  "itemForm/resetItemFormSlice",
  (_, { getState, dispatch }) => {
    const state = getState() as RootState
    const defaultCurrency = state.initSlice.supportedCurrencies.defaultCurrency || ""
    dispatch(resetItemFormSliceWithDefaultCurrency(defaultCurrency))
  }
)
